<template>
    <!-- Initial app load (reload with an active session): light splash with the
         isotipo and the loader beneath it, instead of the dark global overlay. -->
    <div v-if="showInitialLoad" class="initialLoadScreen">
        <img :src="isotipo" alt="Lativo" class="initialLoadLogo" />
        <div class="spinner-border text-light initialLoadSpinner"></div>
    </div>

    <!-- Regular in-app loading overlay -->
    <div v-else-if="store.isLoading" class="spinnerDiv">
        <div class="spinner-border text-light">
        </div>
    </div>
</template>

<script>
import { useStore } from '../../store/DefaultStore.js';

export default{
    name: 'LoadingScreen',
    setup(){
        const store = useStore();

        return{
            store
        }
    },
    data(){
        return {
            isotipo: require('@/svgs/Lat_Isotipo_Lavender.svg')
        }
    },
    computed: {
        // Shows from the start of the initial data load until NavBar + the View
        // have rendered (flag cleared in App.vue's router.afterEach). Guarded to
        // protected routes so it never covers the public login/landing pages.
        showInitialLoad(){
            return this.store.IsInitialLoading
                && !this.$route?.meta?.isPublic;
        }
    }
}
</script>

<style scoped>
.spinnerDiv{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0, 0.5);
    z-index: 9999 !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

.initialLoadScreen{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* Same raisin gradient as the login screen (see .login in App.vue). */
    background-color: rgb(16, 16, 23);
    background-image:
        radial-gradient(ellipse 65% 55% at 14% -6%, rgb(62, 62, 84) 0%, rgba(62, 62, 84, 0) 52%),
        radial-gradient(ellipse 52% 52% at 96% 106%, rgb(46, 46, 66) 0%, rgba(46, 46, 66, 0) 55%),
        linear-gradient(152deg, rgb(40, 40, 57) 0%, rgb(22, 22, 31) 48%, rgb(9, 9, 14) 100%);
    z-index: 9999 !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 50px;
}

.initialLoadLogo{
    width: 96px;
    height: auto;
}

.initialLoadSpinner{
    width: 2rem;
    height: 2rem;
}
</style>
